"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AugustBase = void 0;
const verify_keys_1 = require("./helpers/verify-keys");
class AugustBase {
    constructor({ providers, augustKey }) {
        this.authorized = true;
        if (Object.keys(providers).length === 0)
            throw new Error('Must pass at least 1 provider.');
        this.providers = providers;
        this.activeNetwork = {
            chainId: Number(Object.keys(providers)[0]),
            rpcUrl: Object.values(providers)[0],
        };
        this.augustKey = augustKey;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            const [augustCheck] = yield Promise.all([(0, verify_keys_1.verifyAugustKey)(this.augustKey)]);
            if (!augustCheck)
                throw new Error('August Digital API key is invalid.');
            this.authorized = true;
            console.log('August Digital SDK successfully initialized');
            return;
        });
    }
}
exports.AugustBase = AugustBase;
//# sourceMappingURL=base-class.js.map